const noIndexPages = ['picsartpros', 'revolut-trial'];

export default noIndexPages;
